import { render, staticRenderFns } from "./MenuContentManageImage.vue?vue&type=template&id=74c8f2a1&scoped=true"
var script = {}
import style0 from "./MenuContentManageImage.vue?vue&type=style&index=0&id=74c8f2a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c8f2a1",
  null
  
)

export default component.exports